// extracted by mini-css-extract-plugin
module.exports = {"benefitsSection":"st_benefitsSection__tjo2a","benefitsWrapper":"st_benefitsWrapper___AZ_9","benefit":"st_benefit__vkPke"};